export const createStylesRequests = (client) => ({
    listStyles: async (params) => {
        const { data, meta, links } = await client.api.get("styles", {
            params: params,
        });
        return { data, meta, links };
    },
    findStyle: async (params) => {
        const { data } = await client.api.get(`styles/${params?.filter?.id}`, {
            params: params,
        });
        return { data };
    },
    createStyle: async (payload) => {
        const { data } = await client.api.create("styles", payload);
        return { data };
    },
    updateStyle: async (payload) => {
        const { data } = await client.api.update("styles", payload);
        return { data };
    },
    deleteStyle: async (payload) => {
        const { data } = await client.api.remove("styles", payload?.id);
        return { data };
    },
    approveStyle: async (payload) => {
        const { data } = await client.api.request({
            url: `/styles/${payload?.id}/approve`,
            type: "styles",
            method: "PATCH",
            body: {
                id: payload?.id,
                state: "approved",
            },
        });
        return { data };
    },
    exportStyle: async (payload) => {
        const response = await client.api.request({
            url: `/styles/${payload?.id}/export`,
            type: "styles",
            method: "POST",
            body: payload,
        });
        return response;
    },
    importStyle: async (payload) => {
        const response = await client.api.request({
            url: `/styles/import`,
            type: "styles",
            method: "POST",
            body: payload,
        });
        return response;
    },
    generateGuidelines: async (payload) => {
        const { data } = await client.api.request({
            url: `/styles/${payload?.id}/generate_guidelines`,
            type: "styles",
            method: "POST",
            body: payload,
        });
        return { data };
    },
});
//# sourceMappingURL=index.js.map